import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap-5';
import NewActivityForm from './activity_forms/new_activity_form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faListTimeline } from '@fortawesome/pro-solid-svg-icons';
import ActivityHistory from './activity_history';
import { connect } from 'react-redux';
import { CONTACT_MODEL } from '../../constants';

const TAB_NEW = 'new';
const TAB_LOG = 'log';

function ActivityLog({ activities, callListId, callTemplates, initialActivity, owner, propertyId }) {
  const [tab, setTab] = useState(TAB_NEW);

  const completedActivities = activities.filter((activity) => {
    const isActivity = !activity.isTask || activity.completedAt;
    const forContact = activity.connectedRecordsAttributes.some((record) => {
      if (record.connectedRecordType === CONTACT_MODEL && record.connectedRecordId === owner.contact.id) {
        return true;
      }
      return false;
    });

    return isActivity && forContact;
  });

  return (
    <React.Fragment>
      <Nav activeKey={tab} variant="pills" onSelect={setTab}>
        <Nav.Item>
          <Nav.Link className="activity-pill" eventKey={TAB_NEW}>
            <FontAwesomeIcon className="me-1" icon={faPlusCircle} />
            Create New
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="activity-pill" eventKey={TAB_LOG}>
            <FontAwesomeIcon className="me-1" icon={faListTimeline} />
            History ({completedActivities.length})
          </Nav.Link>
        </Nav.Item>
      </Nav>
      {tab === TAB_NEW && (
        <NewActivityForm
          callListId={callListId}
          callTemplates={callTemplates}
          initialActivity={initialActivity}
          owner={owner}
          propertyId={propertyId}
        />
      )}
      {tab === TAB_LOG && (
        <ActivityHistory activities={completedActivities} />
      )}
    </React.Fragment>
  );
}

ActivityLog.propTypes = {
  activities: PropTypes.array.isRequired,
  callListId: PropTypes.number.isRequired,
  callTemplates: PropTypes.array.isRequired,
  initialActivity: PropTypes.object.isRequired,
  owner: PropTypes.object.isRequired,
  propertyId: PropTypes.number
};

const mapStateToProps = ({ activities }) => ({ activities });
export default connect(mapStateToProps)(ActivityLog);
